import { router } from '../helpers/router';
import {authHeader} from "../helpers/auth-header";

export const userService = {
    login,
    logout,
    forgotPassword,
    verifyAccount,
    resetPassword
};

function login(username, password, thisComponent) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password})
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/login', requestOptions)
        .then(handleLoginResponse)
        .then(accessToken => {
            // login successful if there's an accessToken in the response
            if (accessToken) {
                // store accessToken in local storage
                // to keep user logged in between page refreshes
                localStorage.setItem('accessToken', JSON.stringify(accessToken.content));
                getUser().then(user => thisComponent.$root.$emit('loginLogoutEvent', user));
            }
            const nextPathRoute = localStorage.getItem('nextRoutePath');
            if (nextPathRoute){
                localStorage.removeItem('nextRoutePath');
                router.push(nextPathRoute);
            }else{
                router.push('/');//Navigate the user to the main page
            }

            return accessToken;
        });
}

function logout(routeToLogin, thisComponent) {
    // remove user from local storage to log user out
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    if (thisComponent) {
        thisComponent.$root.$emit('loginLogoutEvent');
    }
    if (routeToLogin){
        router.push('/login');
    }
}

function handleLoginResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload();
            }
            return Promise.reject(data);
        }

        return data;
    });
}

function forgotPassword(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/login/forgot', requestOptions)
        .then(handleResponse);
}


function getUser() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/user/profile', requestOptions)
        .then(handleResponse)
        .then(userProfile => {
            if (userProfile) {
                localStorage.setItem('user', JSON.stringify(userProfile.content));
                return userProfile.content;
            }
        });
}

function verifyAccount(token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/register/verify', requestOptions)
        .then(handleResponse);
}

function resetPassword(password, token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, token })
    };
    return fetch(process.env.VUE_APP_ROOT_API + '/login/reset', requestOptions)
        .then(handleResponse);
}